import React, { Component } from "react";
import { connect } from "react-redux";
import { Accordion, Table } from "semantic-ui-react";
import { parseString } from "xml2js";
import _ from "lodash";
import api from "../../api";
import {
  addItemToProgress,
  removeItemFromProgress,
} from "../../actions/progressList";
import CommonResidencyDetail from "./CommonResidencyDetail";

class CommonResidencyReportSection extends Component {
  state = {
    addresses: [],
    activeIndex: 0,
    savedResultID: "",
    internalID: "",
  };

  componentDidMount() {
    this.loadData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.loadData(nextProps);
      this.setState({ internalID, savedResultID });
    }
  }

  loadSection = (node, props) => {
    const addressesData = _.get(
      node,
      "personReport.common[0].subject[0].addresses[0].address"
    );
    let addresses = [];
    if (addressesData !== undefined) {
      _.forEach(addressesData, (address) => {
        const firstPerson = _.get(address, "sharedAddress[0].person[0]");
        if (firstPerson !== undefined) {
          const dateFrom = _.get(address, "dateFrom[0]._");
          if (dateFrom !== undefined) {
            const tokens = dateFrom.split("/");
            if (tokens.length > 1) {
              address.dateFromRaw = `${tokens[1]}${tokens[0]}`;
            }
          }
          const dateTo = _.get(address, "dateTo[0]._");
          if (dateTo !== undefined) {
            const tokens = dateTo.split("/");
            if (tokens.length > 1) {
              address.dateToRaw = `${tokens[1]}${tokens[0]}`;
            }
          }
          addresses.push(address);
        }
      });
      addresses = _.orderBy(
        addresses,
        ["dateToRaw", "dateFromRaw"],
        ["desc", "desc"]
      );
    }
    const recLength = addresses.length;
    this.setState({
      addresses,
    });
    props.updateItemCountBySection(props.sectionName, recLength);
  };

  loadData = (props) => {
    const sectionNode = _.get(props.reportData, "personReport.common[0]");
    if (sectionNode) {
      this.loadSection(props.reportData, props);
    } else {
      const additionalData = _.cloneDeep(props.additionalData);
      additionalData.requestedSection = "common";
      api.report
        .person(additionalData, props.cancelToken)
        .then((res) => {
          parseString(res.data, { async: false }, (err, rslt) => {
            this.loadSection(rslt, props);
          });
        })
        .catch((err) => console.log("com res error - ", err));
    }
  };

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    const residencyDetails = [];
    if (this.state.addresses !== undefined && this.state.addresses.length > 0) {
      _.forEach(this.state.addresses, (commonResidencyNode, index) => {
        residencyDetails.push(
          <CommonResidencyDetail
            key={`Common_res_detail_${index}`}
            {...this.props}
            commonResidencyNode={commonResidencyNode}
          />
        );
      });
    } else {
      residencyDetails.push(
        <Table key={`no_recs_table`}>
          <Table.Body>
            <Table.Row key={`no_recs_row`}>
              <Table.Cell colSpan={100}>No Records found</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }
    return (
      <Accordion fluid styled id={`nav_${this.props.sectionName}`}>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`ComTitle`}
          onClick={() => this.handleClick()}
        >
          <p>
            Common Residency
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`ComBody`}
          active={this.state.activeIndex === 0}
        >
          {residencyDetails}
        </Accordion.Content>
      </Accordion>
    );
  }
}

function mapStateToProps(state) {
  return {
    cancelToken: state.apiCancelSource
      ? state.apiCancelSource.token
      : undefined,
  };
}

export default connect(mapStateToProps, {
  addItemToProgress,
  removeItemFromProgress,
})(CommonResidencyReportSection);

// export default CommonResidencyReportSection;



// WEBPACK FOOTER //
// ./src/components/reports/CommonResidencyReportSection.js